import { useTranslation } from 'react-i18next';

export const usePermissionsConfig = () => {
  const { t } = useTranslation('modal');

  return {
    defaultPermission: 'view' as const,
    options: [
      { label: t('shareModal.permissionsConfig.view'), value: 'view' },
      { label: t('shareModal.permissionsConfig.edit'), value: 'edit' },
      { label: t('shareModal.permissionsConfig.full'), value: 'full' },
      { label: t('shareModal.permissionsConfig.none'), value: 'none' },
    ],
  };
};
